import { SnapPhotoAndSendRequestSavePhoto } from '../utils/requestModalWebcam';

//@ts-ignore
let toastr: any = window.toastr;
export class WebSocketStudentBuilder {
	websocketStudent: WebSocketStudent;
	webcamStudent: any;

	constructor() {
		this.websocketStudent = new WebSocketStudent();
	}

	setRandomPhotoUrl(random_photo_url: string) {
		this.websocketStudent.random_photo_url = random_photo_url;
		return this;
	}

	setWsScheme(wsScheme: string) {
		this.websocketStudent.wsScheme = wsScheme;
		return this;
	}

	setWsBaseUrl(wsBaseUrl: string) {
		this.websocketStudent.wsBaseUrl = wsBaseUrl;
		return this;
	}

	setClassId(classId: number) {
		this.websocketStudent.classId = classId;
		return this;
	}

	setClientId(clientId: string) {
		this.websocketStudent.clientId = clientId;
		return this;
	}

	setUserId(userId: string) {
		this.websocketStudent.userId = userId;
		return this;
	}
	setUserRegistrantStatus(UserRegistrantStatus: string) {
		this.websocketStudent.UserRegistrantStatus = UserRegistrantStatus;
		return this;
	}

	setMockStudentPhoto(mock_student_photo: boolean) {
		this.websocketStudent.mock_student_photo = mock_student_photo;
		return this;
	}

	setMockStudentPhotoUrl(mock_student_photo_url: string) {
		this.websocketStudent.mock_student_photo_url = mock_student_photo_url;
		return this;
	}

    setClassPausedFunction(func: () => void){
        this.websocketStudent.class_paused_function = func;
        return this;
    }

    setFinishedClassPauseFunction(func: () => void){
        this.websocketStudent.finished_class_pause_function = func;
        return this;
    }

    setStudentBannedFunction(func: () => void) {
        this.websocketStudent.student_banned = func;
        return this;
    }

    setStudentUnbannedFunction(func: () => void) {
        this.websocketStudent.student_unbanned = func;
        return this;
    }

    makeStudentWebSocketUrl() {
		const student = this.websocketStudent;
		student.websocket_url = `${student.wsScheme}://${student.wsBaseUrl}/ws/online-class-${student.classId}-student-${student.userId}?client_id=${student.clientId}`;
		return this;
	}

	makeGeneralWebSocket() {
		const general = this.websocketStudent;
		general.websocket_url = `${general.wsScheme}://${general.wsBaseUrl}/ws/online-class-${general.classId}-all?client_id=${general.clientId}`;
		return this;
	}

	build() {
		return this.websocketStudent;
	}
}

class WebSocketStudent {
	websocket_url: string = '';
	ws: WebSocket | undefined = undefined;
	mock_student_photo: boolean = false;
	mock_student_photo_url: string | null = null;
	wsScheme: string | null = null;
	wsBaseUrl: string | null = null;
	classId: number | null = null;
	clientId: string | null = null;
	userId: string | null = null;
	random_photo_url: string = '';
	UserRegistrantStatus: string = '';
    class_paused_function: () => void;
    finished_class_pause_function: () => void;
    student_banned: () => void = () => {};
    student_unbanned: () => void = () => {};

    constructor() {
        this.class_paused_function = () => {
            alert('O seu instrutor(a) iniciou o intervalo, não serão feitas solicitações para fazer biometrias nesse período.')
        }

        this.finished_class_pause_function = () => {};
    }

	connectWs() {
		this.ws = new WebSocket(this.websocket_url);
		this.ws.onmessage = (message) => {
			this.receiveMessage(message);
		};

		this.ws.onclose = (message) => {
			console.log(
				`Websocket closed: ${
					this.ws?.readyState === WebSocket.CLOSED
				}, restarting connection...`
			);
			setTimeout(() => {
				this.connectWs();
			}, 2000);
		};

		this.ws.onerror = (message) => {
			console.log(
				'Reconnecting websocket, something went wrong. Error:',
				message
			);
			setTimeout(() => {
				this.connectWs();
			}, 2000);
		};

		this.ws.onopen = (message) => {
			console.log(
				'Websocket connected:',
				this.ws?.readyState === WebSocket.OPEN
			);
		};
	}

	receiveMessage(message) {
		if (message['data'] instanceof Blob) {
			message['data'].text().then((e) => {
				this.processMessage(JSON.parse(e));
			});
		} else {
			const data = JSON.parse(message['data']);
			this.processMessage(data);
		}
	}

	processMessage(message) {
		switch (message['event']) {
			case 'MESSAGE/NEW':
				switch (message['subevent']) {
					case 'INSTRUCTOR_TO_STUDENT':
						toastr.info(message['message']);
						break;
					case 'STUDENTS_SELECTED':
						toastr.success(
							'Você foi selecionado para a biometria aleatória.'
						);
						break;
					case 'RANDOM_STUDENT_PHOTO':
						if (this.UserRegistrantStatus !== 'REGISTERED') {
							toastr.warning(
								`Uma foto vai ser tirada em até 5 segundos`,
								'',
								{ timeOut: 5000 }
							);
							new SnapPhotoAndSendRequestSavePhoto(
								this.random_photo_url,
								this.mock_student_photo_url
							);
						}
						break;
					case 'START_CLASS':
						$('#button-start-class').click();
						break;
					case 'FINISH_CLASS':
						$('#button-close-class').click();
						break;
                    case 'STUDENT_BANNED':
                        this.student_banned()
                        break;
                    case 'STUDENT_UNBANNED':
                        this.student_unbanned()
                        break;
					default:
						break;
				}
				break;
            case 'STARTED_CLASS_PAUSE':
                toastr.info('Intervalo iniciado pelo instrutor');
                this.class_paused_function();
                break;
            case 'FINISHED_CLASS_PAUSE':
                toastr.info('Intervalo finalizado pelo instrutor');
                this.finished_class_pause_function();
                break;
			default:
				break;
		}
	}
}
